import React, { Component, Fragment } from 'react'
import SafeRetirementBar from './SafeRetirementBar'
import SafeRetirementTextIndicator from './SafeRetirementTextIndicator'

// NOTE: This component cannot be removed since it is used
// by joint planning. 
// Either extend the new components/SafeRetirementIndicator 
// to include the joint planning logic or wait until joint planning
// moves to be part of the scenario model.
export default class SafeRetirement extends Component {
  constructor (props) {
    super(props)

    this.state = {
      percentage: props.percentage,
      text: props.text,
      statusObjects: props.statusObjects || null
    }
  }

  componentDidMount () {
    window.addEventListener('retirementScenarioUpdated', (e) => {
      this.setState({
        percentage: e.detail.safe_retirement_data.percentage,
        text: e.detail.safe_retirement_data.text
      })
    })
  }

  render () {
    if (this.state.statusObjects) {
      return (
        <div className='ui-card ui-card--safe-retirement-indicator'>
          {
            this.state.statusObjects.map((statusObject, idx) =>
              <Fragment key={idx}>
                <SafeRetirementTextIndicator name={statusObject.name} withoutHeader={idx !== 0} text={statusObject.text} />
                <SafeRetirementBar percentage={statusObject.percentage} />
              </Fragment>
            )
          }
        </div>
      )
    } else {
      return (
        <div className='ui-card ui-card--safe-retirement-indicator'>
          <SafeRetirementTextIndicator text={this.state.text} />
          <SafeRetirementBar percentage={this.state.percentage} />
        </div>
      )
    }
  }
}
